import { NgModule } from '@angular/core';

import { DestinosComponent } from './destinos.component';
import {SharedModule} from "../../shared/shared.module";
import {DestinosRoutingModule} from "./destinos-routing.module";
import {DestinoApiService} from "./shared/destino-api.service";
import {DestinoNavigationService} from "./shared/destino-navigation.service";
import {DestinoService} from "./shared/destino.service";
import {DestinoFormComponent} from "./destino-form/destino-form.component";
import {DestinoListComponent} from "./destino-list/destino-list.component";

@NgModule({
    imports: [
        SharedModule,
        DestinosRoutingModule
    ],
    providers: [
        DestinoApiService,
        DestinoNavigationService,
        DestinoService
    ],
    declarations: [
        DestinosComponent,
        DestinoFormComponent,
        DestinoListComponent
    ]
})
export class DestinosModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/destinos/destinos.module.ts
 **/